export const API_URL = {
  // new API Threshold
  URL_THRESHOLD_SETTING: '/threshold-settings',
  URL_GET_TOLERANCE: '/threshold-settings/get-tolerance',
  // Car Loan API
  URL_GET_BASIC_FUEL: 'pattern-s3-c15/10/basic-fuel',
  URL_GET_FUEL_TYPE: 'pattern-s3-c15/10/vehicle-fuel-efficiency',
  URL_GET_VEHICLE_FUEL_EFFICIENCY: 'pattern-s3-c15/10/vehicle-fuel-efficiency',
  URL_GET_VEHICLE_TYPE: 'pattern-s3-c15/10/vehicle-type',
  URL_GET_DISTANCE_BY_REGION: 'pattern-s3-c15/10/distance-by-region',
  URL_GET_CAR_MODEL: 'pattern-s3-c15/10/car-model',
};
